export const objectStorageLocations = {
  wnam: 'Western North America',
  enam: 'Eastern North America',
  weur: 'Western Europe',
  eeur: 'Eastern Europe',
  apac: 'Asia-Pacific',
  oc: 'Oceania',
}
